/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createTeamMembershipBodyUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createTeamMembershipBodyExpectedTeamVersionExclusiveMin = 0;
export const createTeamMembershipBodyExpectedTeamVersionMax = 9007199254740991;

export const CreateTeamMembershipBody = zod.object({
  userId: zod.uuid().regex(createTeamMembershipBodyUserIdRegExp),
  expectedTeamVersion: zod
    .int()
    .gt(createTeamMembershipBodyExpectedTeamVersionExclusiveMin)
    .max(createTeamMembershipBodyExpectedTeamVersionMax),
});

export type CreateTeamMembershipBody = zod.input<typeof CreateTeamMembershipBody>;
export type CreateTeamMembershipBodyOutput = zod.output<typeof CreateTeamMembershipBody>;
